<template>
    <div v-if="modal.show" class="vue-modal">
        <div class="vue-modal__wrap">
            <div class="popup popup--vue">
                <div class="hero">
                    <div class="account__container pb-xl">
                        <h1 class="h3 hero__title">Job Details</h1>
                        <Steps :current="steps.active" :total="steps.total" @changeStep="stepForm" />
                    </div>
                </div>

                <form class="account__container" @submit.prevent>
                    <StepOne v-if="steps.active === 1" ref="1" />
                    <StepTwo v-if="steps.active === 2" ref="2" />
                    <StepThree v-if="steps.active === 3" ref="3" />

                    <div class="submit">
                        <button v-if="isLastStep" class="btn" @click="submitForm">Done</button>
                        <button v-else class="btn" @click="stepForm()">Next</button>
                        <button class="btn ml-base js-popup-close-new-job" @click="resetAndClose">Cancel</button>
                    </div>

                    <template v-if="hasErrors">
                        <p v-for="error in errors" :key="error" class="mt-sm small semi text--orange">{{ error }}</p>
                    </template>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import modal from '@/modal';

import Steps from '@/jobs/new/Steps';
import StepOne from '@/jobs/new/steps/one';
import StepTwo from '@/jobs/new/steps/two';
import StepThree from '@/jobs/new/steps/three';

// import { EventBus } from '@/event-bus';

export default {
    components: {
        Steps,
        StepOne,
        StepTwo,
        StepThree
    },

    mixins: [modal],

    data() {
        return {
            steps: {
                active: 1,
                total: 3
            },
            errors: [],
        };
    },

    computed: {
        nextStep() {
            return this.steps.active + 1;
        },

        isLastStep() {
            return this.steps.total === this.steps.active;
        },

        hasErrors() {
            return this.errors.length;
        }
    },

    created() {
        // Preload diagram images
        new Image().src = '/dist/images/job/mppt-1-grey.svg';
        new Image().src = '/dist/images/job/mppt-1-orange.svg';
        new Image().src = '/dist/images/job/mppt-2-grey.svg';
        new Image().src = '/dist/images/job/mppt-2-orange.svg';

        new Image().src = '/dist/images/job/mppt-1-grey-mobile.svg';
        new Image().src = '/dist/images/job/mppt-1-orange-mobile.svg';
        new Image().src = '/dist/images/job/mppt-2-grey-mobile.svg';
        new Image().src = '/dist/images/job/mppt-2-orange-mobile.svg';
    },

    methods: {
        ...mapActions('job', { createJob: 'createJob', updateJob: 'updateJob', resetJobState: 'resetState' }),
        ...mapActions('products', { resetProductState: 'resetState' }),
        ...mapActions('configuration', { resetConfigState: 'resetState' }),

        validateStep() {
            const validationObj = this.$refs[this.steps.active].$v;
            if (!validationObj) return true;

            validationObj.$touch();

            if (validationObj.$invalid) this.errors = ['You have errors. Please check above for more details.'];
            return !validationObj.$invalid;
        },

        stepForm(goto = null) {
            const nextStep = goto ? goto : this.nextStep;

            // Only validate if stepping forward
            if (nextStep > this.steps.active) {
                if (this.validateStep()) {
                    this.steps.active = nextStep;
                    this.errors = [];

                    // GTM for steps creating a new job
                    if ('dataLayer' in window && !goto && !this.$root.editMode) {
                        window.dataLayer.push({
                            event: 'newJob',
                            step: `step${this.steps.active - 1}`
                        });
                    }
                }
            } else {
                this.steps.active = nextStep;
                this.errors = [];
            }
        },

        async submitForm() {
            if (this.validateStep()) {
                const endpoint = this.$root.editMode ? this.updateJob : this.createJob;

                const response = await endpoint();
                if (response.success) {
                    const jobId = response.job.id;
                    window.location = `/account/job/${jobId}`;
                    // this.resetAndClose();
                    // EventBus.$emit('new-job-added');

                    // GTM for completing a new job
                    if ('dataLayer' in window && !this.$root.editMode) {
                        window.dataLayer.push({
                            event: 'newJob',
                            step: 'complete'
                        });
                    }

                } else {
                    this.errors = response.errors;
                }
            }
        },

        resetAndClose() {
            this.steps.active = 1;
            this.resetJobState();
            this.resetProductState();
            this.resetConfigState();
            this.close();
        }
    },
};
</script>

<style lang="scss" scoped>
    .vue-modal__wrap {
        margin: 2px;
    }

    .hero .account__container {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-end;
    }

    .hero__title {
        margin-right: 1em;
    }

    .submit {
        display: flex;
        margin-left: -5px;

        .btn {
            margin-right: 8px;

            @media screen and (max-width: 799px) {
                flex: 1;
                min-width: 0;
            }
        }
    }
</style>
